import it from './newsPage.it.json';
import en from './newsPage.en.json';

const newsPageContent = { it, en };

export default newsPageContent;
